import Vue from 'vue';
import VueI18n from 'vue-i18n';

import lang from '../lang/messages';

import type { LocaleMessages } from 'vue-i18n';

// import { connector } from '../services/connector';

Vue.use(VueI18n);

// connector
//   .get('pyramid.locdata', null, {
//     component: 'custom_webmap',
//     locale: 'ru',
//   })
//   .then((x) => {
//     console.log(x);
//   });

const locale = (window.ngwConfig && window.ngwConfig.locale) || 'en';

export async function createI18n(): Promise<VueI18n> {
  const messages = {
    [locale]: await lang,
  } as LocaleMessages;

  const i18n = new VueI18n({
    locale, // set locale
    messages, // set locale messages
    silentTranslationWarn: true,
    silentFallbackWarn: true, // process.env.NODE_ENV === 'production',
  });
  return i18n;
}
